import { render, staticRenderFns } from "./CommentBtn.vue?vue&type=template&id=9cfdbae0"
import script from "./CommentBtn.vue?vue&type=script&lang=js"
export * from "./CommentBtn.vue?vue&type=script&lang=js"
import style0 from "./CommentBtn.vue?vue&type=style&index=0&id=9cfdbae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports